export default __webpack_public_path__ + "static/media/2024JaneNohResume-2.66adcb26.pdf";